<template>
  <DxPopup
    :visible="visible"
    :show-title="true"
    :title="$t('scale.weighing_on_scale.product_label_classification_popup_title')"
    :width="640"
    :height="360"
    :drag-enabled="true"
    :close-on-outside-click="false"
    content-template="popupContent"
    @hiding="onCancel"
  >
    <template #popupContent>
      <div class="product-label-popup-content">
        <div class="product-label-popup-description">
          {{ $t('scale.weighing_on_scale.product_label_classification_popup_description') }}
        </div>

        <DxComboBox
          v-model="selectedUuid"
          :data-source="labels"
          value-expr="uuid"
          display-expr="name"
          :show-clear-button="false"
          :search-enabled="true"
          :placeholder="$t('scale.weighing_on_scale.product_label_classification_placeholder')"
          class="product-label-popup-dropdown"
        />

        <div class="product-label-popup-actions">
          <SmagriaButton :label="$t('common.cancel')" :action="onCancel" :customClass="'secondary border'" />
          <SmagriaButton
            :label="$t('scale.weighing_on_scale.product_label_classification_save_without_label')"
            :action="onSaveWithoutLabel"
            :customClass="'secondary border'"
          />
          <SmagriaButton :label="$t('common.save')" :action="onSave" :customClass="'primary'" />
        </div>
      </div>
    </template>
  </DxPopup>
</template>

<script>
import { DxPopup } from "devextreme-vue/popup";
import DxComboBox from "devextreme-vue/select-box";
import SmagriaButton from "@/components/Common/SmagriaButton.vue";
import { errorMessage } from "@/helpers/common";

export default {
  name: "ProductLotCategoryLabelPopup",
  data() {
    return {
      visible: false,
      labels: [],
      selectedUuid: null,
      promiseResolve: null,
    };
  },
  components: {
    DxPopup,
    DxComboBox,
    SmagriaButton,
  },
  methods: {
    open({ labels = [], selectedUuid = null } = {}) {
      return new Promise((resolve) => {
        this.labels = Array.isArray(labels) ? labels : [];
        this.selectedUuid = selectedUuid || null;
        this.promiseResolve = resolve;
        this.visible = true;
      });
    },
    closeWith(result) {
      this.visible = false;
      if (this.promiseResolve) {
        this.promiseResolve(result);
      }
      this.promiseResolve = null;
      this.labels = [];
      this.selectedUuid = null;
    },
    onCancel() {
      this.closeWith(null);
    },
    onSaveWithoutLabel() {
      this.closeWith({ action: "save_without_label" });
    },
    onSave() {
      if (!this.selectedUuid) {
        errorMessage(this, this.$t("scale.weighing_on_scale.error_product_label_classification_required"));
        return;
      }

      this.closeWith({ action: "save_with_label", label_uuid: this.selectedUuid });
    },
  },
};
</script>

<style scoped>
.product-label-popup-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 12px;
}

.product-label-popup-description {
  font-weight: 500;
}

.product-label-popup-dropdown {
  margin-top: 4px;
}

.product-label-popup-actions {
  margin-top: auto;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
</style>
